import { render, staticRenderFns } from "./kbmb.vue?vue&type=template&id=0f9a9a67&scoped=true&"
import script from "./kbmb.vue?vue&type=script&lang=js&"
export * from "./kbmb.vue?vue&type=script&lang=js&"
import style0 from "./kbmb.vue?vue&type=style&index=0&id=0f9a9a67&prod&lang=scss&scoped=true&"
import style1 from "./kbmb.vue?vue&type=style&index=1&id=0f9a9a67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a9a67",
  null
  
)

export default component.exports